import { Stack } from 'expo-router';

export default function QuestionInstanceLayout() {
    return <Stack screenOptions={{ headerShown: false }} />;
}
